import { GET_LEAD_HISTORY, GET_LEAD_HISTORY_ERR } from '../../actionTypes/leadsType'
import { getLeadHistoryApi } from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const getLeadHistory = (payload) => async (dispatch) => {
    try {
        let results = await axios.get(`${getLeadHistoryApi}/${payload.lead_id}/${payload.page}`, await accessToken())
        let data = results && results.data
        console.log('GET Leads', data)
        dispatch({
            type: GET_LEAD_HISTORY,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_LEAD_HISTORY_ERR,
            payload: error.response,
        });
    }
};


